'use client'

import { createContext, useContext, type ReactNode } from 'react'
import type { FlagKey, FlagValues } from '../keys'

const FlagContext = createContext<Partial<FlagValues>>({})

export function FlagClientProvider({
  values,
  children,
}: {
  values: Partial<FlagValues>
  children: ReactNode
}) {
  return <FlagContext.Provider value={values}>{children}</FlagContext.Provider>
}

// Reads a flag resolved on the server. Vercel Flags has no client-side
// evaluator by design; the value is decided server-side (honouring dashboard
// rules and Toolbar overrides) and passed down through this context.
export function useFlag(flagKey: FlagKey): boolean {
  return useContext(FlagContext)[flagKey] ?? false
}
